import NutritionalFactsTable from "../../../../components/reusables/nutritionalFactsTable";

const ComboNutritionalInfoForm = ({ formik }) => {
    return (
        <div className="space-y-6 max-w-5xl mx-auto">
            <NutritionalFactsTable
                value={formik.values.nutrition}
                onChange={(rows) => {
                    formik.setFieldValue('nutrition', rows);
                }}
            />
        </div>
    );
};

export default ComboNutritionalInfoForm;
